<template lang="pug">
.slot-menu
  ul.flex-fill
    template(v-for="item in categoryMenu")
      template(v-if="item === 'favorite'")
        template(v-if="favGame && favGame.length > 0")
          li.filter(:data-filter='item == "all" ? item : "filter-" + item' :data-name='item' @click="setGameMenu(item)")
            a(href="javascript:void(0);")
              .menu-icon
                img(:src="'images/menu/' + item + '.png'")
              .menu-icon-active
                img(:src="'images/menu/' + item + '-active.png'")
              .menu-text {{ $t("ui." + item) }}
      template(v-else)
        li.filter(:data-filter='item == "all" ? item : "filter-" + item' :data-name='item' @click="setGameMenu(item)")
          a(href="javascript:void(0);")
            .menu-icon
              img(:src="'images/menu/' + item + '.png'")
            .menu-icon-active
              img(:src="'images/menu/' + item + '-active.png'")
            .menu-text {{ $t("ui." + item) }}
    li.selected-slot.active
      a(href="javascript:void(0);")
        .menu-icon
          img(:src="'images/slot/' + provider.toLowerCase() + '.png'")
        .menu-icon-active
          img(:src="'images/slot/' + provider.toLowerCase() + '-active.png'")
  .categories-search
    .input-group
      span.input-group-text
        i.fa-solid.fa-magnifying-glass
      input.form-control(v-model="search" type='text' :placeholder="$t('ui.search_game')" @input="handleSearch")
</template>

<script>
export default {
  data() {
    return{
      categoryMenu: ['all','favorite'],
      search: ""
    }
  },
  computed:{
    isLoggedIn(){
      return this.$store.getters.isLoggedIn
    },
    accountID() {
      return this.$store.getters.accountID
    },
    sessionToken() {
      return this.$store.getters.sessionToken
    },
    getLanguage() {
      return this.$store.getters.language
    },
    providerList() {
      return this.$store.state.user.account.provider_list.filter(item => item.enable_provider === true)
    },
    favGame() {
      return this.$store.getters.favGame
    },
    provider() {
      return this.$store.getters.provider
    }
  },
  methods: {
    setGameMenu(game) {
      this.$router.push("/").then(() => {
        this.$store.dispatch("user/setGameMenuSelected", game)
      })
    },
    handleSearch() {
      this.$emit('search', this.search)
    }
  }
}
</script>